import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-700 to-blue-500 py-8 px-4">
      <div className="max-w-4xl mx-auto bg-black/40 backdrop-blur-md shadow-xl rounded-lg p-8 border border-blue-500/20">
        <Link
          to="/"
          className="inline-flex items-center text-cyan-300 hover:text-cyan-200 transition-colors mb-8 group"
        >
          <ArrowLeft className="h-5 w-5 mr-2 transition-transform group-hover:-translate-x-1" />
          Back to Home
        </Link>

        <h1 className="text-4xl font-bold text-white mb-8 bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">Privacy Policy</h1>
        
        <div className="space-y-8 text-lg">
          <p className="text-cyan-200">Last updated: January 23, 2025</p>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white border-b border-blue-500/30 pb-2">1. Information We Collect</h2>
            <p className="text-gray-300 leading-relaxed">
              We collect information you provide directly to us when you create an account, update your profile, or communicate with us.
              This may include your name, email address, phone number, and other profile information.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white border-b border-blue-500/30 pb-2">2. How We Use Your Information</h2>
            <p className="text-gray-300 leading-relaxed">
              We use the information we collect to provide, maintain, and improve our services, communicate with you,
              and protect our users and services.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white border-b border-blue-500/30 pb-2">3. Information Sharing</h2>
            <p className="text-gray-300 leading-relaxed">
              We do not share your personal information with third parties except as described in this policy
              or with your explicit consent.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white border-b border-blue-500/30 pb-2">4. Security</h2>
            <p className="text-gray-300 leading-relaxed">
              We take reasonable measures to help protect your personal information from loss, theft, misuse,
              unauthorized access, disclosure, alteration, and destruction.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white border-b border-blue-500/30 pb-2">5. Contact Us</h2>
            <p className="text-gray-300 leading-relaxed">
              If you have any questions about this Privacy Policy, please contact us via <a href="https://t.me/teamiccc" target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:text-cyan-300 underline">Telegram</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
